// extracted by css-extract-rspack-plugin
export default {"cls1":"FeedbackPopover-cls1_MRw","cls2":"FeedbackPopover-cls2_tlf FeedbackPopover-cls1_MRw"};